import React from 'react';
import { ArrowRight, Phone, Sparkles, AlertTriangle } from 'lucide-react';
import { FadeIn } from './Animations';
export const BeforeAfter = () => {
  return <section className="py-20 md:py-24 bg-brand-gray relative overflow-hidden" data-id="element-23">
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-brand-red/5 rounded-full blur-3xl pointer-events-none" data-id="element-24" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-brand-black/5 rounded-full blur-3xl pointer-events-none" data-id="element-25" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <FadeIn className="text-center max-w-2xl mx-auto mb-12" data-id="element-27">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-red mb-4" data-id="element-28">
            Real Transformations
          </div>
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase text-brand-black leading-tight" data-id="element-29">
            See The <span className="text-brand-red" data-id="element-30">Difference</span>
          </h2>
          <p className="text-zinc-600 text-lg mt-4" data-id="element-31">
            From cluttered chaos to clean, usable space — this is what one phone
            call to Jez looks like.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-32">
          <div className="relative rounded-sm overflow-hidden shadow-2xl border-4 border-white" data-id="element-33">
            {/* Image */}
            <img src="https://cdn.magicpatterns.com/uploads/rUZZZJRrXVQqjVGBUQnP3V/JEZ2.png" alt="Before and after Jez Junk Away service - driveway transformation" className="w-full h-auto object-cover block" data-id="element-34" />

            {/* Center divider line */}
            <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-1 bg-brand-red shadow-lg pointer-events-none z-10" data-id="element-35" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-brand-red rounded-full shadow-xl flex items-center justify-center z-20 border-4 border-white" data-id="element-36">
              <ArrowRight className="w-5 h-5 text-white" data-id="element-37" />
            </div>

            {/* BEFORE label */}
            <div className="absolute top-4 left-4 md:top-6 md:left-6 z-10" data-id="element-38">
              <div className="bg-brand-black/90 backdrop-blur text-white px-4 py-2 md:px-5 md:py-3 rounded-sm flex items-center gap-2 border-l-4 border-brand-red shadow-xl" data-id="element-39">
                <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-brand-red" data-id="element-40" />
                <span className="font-oswald font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-41">
                  Before
                </span>
              </div>
            </div>

            {/* AFTER label */}
            <div className="absolute top-4 right-4 md:top-6 md:right-6 z-10" data-id="element-42">
              <div className="bg-brand-red text-white px-4 py-2 md:px-5 md:py-3 rounded-sm flex items-center gap-2 shadow-xl" data-id="element-43">
                <Sparkles className="w-4 h-4 md:w-5 md:h-5" data-id="element-44" />
                <span className="font-oswald font-bold uppercase tracking-wider text-sm md:text-base" data-id="element-45">
                  After
                </span>
              </div>
            </div>

            {/* Bottom info bars */}
            <div className="absolute bottom-0 left-0 right-0 grid grid-cols-2 z-10" data-id="element-46">
              <div className="bg-brand-black/85 backdrop-blur text-white p-4 md:p-5 border-r-2 border-brand-red" data-id="element-47">
                <p className="font-oswald font-bold uppercase text-sm md:text-base leading-tight" data-id="element-48">
                  Junk, debris &amp; clutter
                </p>
                <p className="text-zinc-300 text-xs md:text-sm mt-1" data-id="element-49">
                  Years of stuff piling up
                </p>
              </div>
              <div className="bg-brand-red/95 backdrop-blur text-white p-4 md:p-5" data-id="element-50">
                <p className="font-oswald font-bold uppercase text-sm md:text-base leading-tight" data-id="element-51">
                  Clean &amp; usable space
                </p>
                <p className="text-red-50 text-xs md:text-sm mt-1" data-id="element-52">
                  One call. Same day. Done.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-53">
          <div className="mt-10 text-center" data-id="element-54">
            <p className="text-zinc-700 text-lg mb-6" data-id="element-55">
              <strong className="text-brand-black" data-id="element-56">
                This could be your driveway tomorrow.
              </strong>{' '}
              Call or text a photo for a free estimate.
            </p>
            <a href="tel:+15597709442" className="inline-flex items-center justify-center gap-3 bg-brand-red hover:bg-brand-darkred text-white px-8 py-4 rounded-sm font-bold text-lg transition-all uppercase tracking-wide shadow-xl shadow-brand-red/20 hover:shadow-2xl hover:shadow-brand-red/40" data-id="element-57">
              <Phone className="w-5 h-5" data-id="element-58" />
              Call (559) 770-9442
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
};